import React from 'react';

export const AddNewScheduleIcon = (props) => {
  const { className = '', style = {}, onClick, disabled = false } = props;
  return (
    <svg
      className={className}
      onClick={disabled ? null : onClick}
      style={style}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.3051 24.833H15.2548L15.2501 24.8193L15.3051 24.833Z" fill="#003252" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.2548 24.833H6.30642V12.821H23.9736V16.0545C24.4139 16.1095 24.8404 16.2058 25.267 16.3297C25.6935 16.4535 26.0925 16.6049 26.4916 16.7837V8.00518C26.4916 7.34473 26.2439 6.78059 25.7486 6.31277C25.2532 5.84494 24.6616 5.61103 23.9598 5.61103H22.694V4.469C22.694 3.76726 22.1298 3.20312 21.4281 3.20312C20.7264 3.20312 20.1622 3.76726 20.1622 4.469V5.61103H10.0628V4.469C10.0628 3.76726 9.49862 3.20312 8.79689 3.20312C8.09515 3.20312 7.53101 3.76726 7.53101 4.469V5.61103H6.26514C5.57717 5.61103 4.97175 5.84494 4.47641 6.31277C3.98107 6.78059 3.7334 7.34473 3.7334 8.00518V24.833C3.7334 25.4935 3.98107 26.0576 4.47641 26.5254C4.97175 26.9933 5.56341 27.2272 6.26514 27.2272H16.4884C16.2132 26.8694 15.9793 26.4842 15.7729 26.0851C15.5687 25.6903 15.4049 25.2685 15.2548 24.833ZM6.30642 8.00518H23.9736V10.4131H6.30642V8.00518Z"
        fill="#003252"
      />
      <path
        d="M9.52628 14.4586H8.24665C8.00348 14.4586 7.80635 14.6557 7.80635 14.8989V16.1785C7.80635 16.4217 8.00348 16.6188 8.24665 16.6188H9.52628C9.76945 16.6188 9.96658 16.4217 9.96658 16.1785V14.8989C9.96658 14.6557 9.76945 14.4586 9.52628 14.4586Z"
        fill="#003252"
      />
      <path
        d="M9.52628 17.6094H8.24665C8.00348 17.6094 7.80635 17.8065 7.80635 18.0497V19.3293C7.80635 19.5725 8.00348 19.7696 8.24665 19.7696H9.52628C9.76945 19.7696 9.96658 19.5725 9.96658 19.3293V18.0497C9.96658 17.8065 9.76945 17.6094 9.52628 17.6094Z"
        fill="#003252"
      />
      <path
        d="M8.24665 20.7594H9.52628C9.76945 20.7594 9.96658 20.9565 9.96658 21.1997V22.4793C9.96658 22.7225 9.76945 22.9196 9.52628 22.9196H8.24665C8.00348 22.9196 7.80635 22.7225 7.80635 22.4793V21.1997C7.80635 20.9565 8.00348 20.7594 8.24665 20.7594Z"
        fill="#003252"
      />
      <path
        d="M12.6497 14.4586H11.3701C11.1269 14.4586 10.9298 14.6557 10.9298 14.8989V16.1785C10.9298 16.4217 11.1269 16.6188 11.3701 16.6188H12.6497C12.8929 16.6188 13.09 16.4217 13.09 16.1785V14.8989C13.09 14.6557 12.8929 14.4586 12.6497 14.4586Z"
        fill="#003252"
      />
      <path
        d="M11.3701 17.6094H12.6497C12.8929 17.6094 13.09 17.8065 13.09 18.0497V19.3293C13.09 19.5725 12.8929 19.7696 12.6497 19.7696H11.3701C11.1269 19.7696 10.9298 19.5725 10.9298 19.3293V18.0497C10.9298 17.8065 11.1269 17.6094 11.3701 17.6094Z"
        fill="#003252"
      />
      <path
        d="M12.6497 20.7594H11.3701C11.1269 20.7594 10.9298 20.9565 10.9298 21.1997V22.4793C10.9298 22.7225 11.1269 22.9196 11.3701 22.9196H12.6497C12.8929 22.9196 13.09 22.7225 13.09 22.4793V21.1997C13.09 20.9565 12.8929 20.7594 12.6497 20.7594Z"
        fill="#003252"
      />
      <path
        d="M14.5071 14.4586H15.7867C16.0299 14.4586 16.227 14.6557 16.227 14.8989V16.1785C16.227 16.4217 16.0299 16.6188 15.7867 16.6188H14.5071C14.2639 16.6188 14.0668 16.4217 14.0668 16.1785V14.8989C14.0668 14.6557 14.2639 14.4586 14.5071 14.4586Z"
        fill="#003252"
      />
      <path
        d="M15.7867 17.6094H14.5071C14.2639 17.6094 14.0668 17.8065 14.0668 18.0497V19.3293C14.0668 19.5725 14.2639 19.7696 14.5071 19.7696H15.7867C16.0299 19.7696 16.227 19.5725 16.227 19.3293V18.0497C16.227 17.8065 16.0299 17.6094 15.7867 17.6094Z"
        fill="#003252"
      />
      <path
        d="M17.6305 14.4586H18.9102C19.1533 14.4586 19.3505 14.6557 19.3505 14.8989V16.1785C19.3505 16.4217 19.1533 16.6188 18.9102 16.6188H17.6305C17.3874 16.6188 17.1902 16.4217 17.1902 16.1785V14.8989C17.1902 14.6557 17.3874 14.4586 17.6305 14.4586Z"
        fill="#003252"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6537 22.9901C16.6537 19.7841 19.2543 17.1836 22.4602 17.1836C25.6662 17.1836 28.2667 19.7841 28.2667 22.9901C28.2667 26.1961 25.6662 28.7966 22.4602 28.7966C19.2543 28.7966 16.6537 26.1961 16.6537 22.9901ZM23.5885 24.1184H25.0607C25.6799 24.1184 26.1753 23.623 26.1753 23.0039C26.1753 22.3847 25.6799 21.8893 25.0607 21.8893H23.5885V20.4171C23.5885 19.7979 23.0931 19.3026 22.474 19.3026C21.8548 19.3026 21.3595 19.7979 21.3595 20.4171V21.8893H19.8872C19.268 21.8893 18.7727 22.3847 18.7727 23.0039C18.7727 23.623 19.268 24.1184 19.8872 24.1184H21.3595V25.5906C21.3595 26.2098 21.8548 26.7052 22.474 26.7052C23.0931 26.7052 23.5885 26.2098 23.5885 25.5906V24.1184Z"
        fill="#003252"
      />
    </svg>
  );
};

// Figma: new event
